import React from 'react'
import { useTeamsStore } from '@/stores/teamsStore'

interface TeamFlairBadgeProps {
  teamId: string | null | undefined
  size?: 'xs' | 'sm' | 'md'
  className?: string
}

const sizeMap = {
  xs: 'w-4 h-4',
  sm: 'w-5 h-5',
  md: 'w-7 h-7',
} as const

/**
 * Renders a tiny team logo badge next to a user's name.
 * Gracefully returns null if teamId is missing or team not found.
 */
export const TeamFlairBadge: React.FC<TeamFlairBadgeProps> = ({ teamId, size = 'sm', className = '' }) => {
  const team = useTeamsStore(s => teamId ? s.teamsById[teamId] : undefined)

  if (!team?.logo) return null

  return (
    <img
      src={team.logo}
      alt={team.shortName || team.name}
      title={team.shortName || team.name}
      className={`${sizeMap[size]} rounded object-contain bg-white/10 p-px flex-shrink-0 ${className}`}
    />
  )
}
